<sas-shell>
  @if (isLoggedIn) {
    <sas-notifications headerActions />
  }
</sas-shell>
